import React from 'react';
import Carousel from '../../Components/home/Carousel/Carousel';
import Preferences from '../../Components/home/Preferences/Preferences';
import About from '../../Components/home/About/About';
import Contact from '../../Components/home/Contact/Contact';
import ServicesShort from '../../Components/home/ServicesShort/ServicesShort';
import Header from '../../Components/Header/Header'; 
import Offices from '../../Components/home/Offices/Offices';



const Home = () => {
  return (
    <>
    <Header/>
    <Carousel/>
    <ServicesShort/>
    <About/> 
    <Offices/>
    <Preferences/>
    <Contact/>
    </>
  )
}

export default Home;